import React, { useState } from 'react';
import Tabs from "react-bootstrap/Tabs";
import {Tab} from "react-bootstrap";
import RaceService from "../../services/RaceService";
import LeaderBoard from "../../components/LeaderBoard/LeaderBoardContainer";
// import Schedule from "../../components/Schedule/Schedule";

const LEADERBOARD = 'leaderboard';
// const EVENT_SCHEDULE = 'eventSchedule';

function HomePageMobile() {
    const [activeTab, setActiveTab] = useState(LEADERBOARD);
    const onSelect = (key) => setActiveTab(key);

    return (
        <div className="home-page-mobile-container">
            <Tabs activeKey={activeTab} onSelect={onSelect}>
                <Tab eventKey={LEADERBOARD} title="LEADERBOARD" className="justify-content-center">
                    <LeaderBoard RaceService={RaceService} isMobile={true}/>
                </Tab>
                {/* <Tab eventKey={EVENT_SCHEDULE} title="EVENT SCHEDULE" className="justify-content-center">
                    <Schedule isActive={activeTab === EVENT_SCHEDULE} />
                </Tab> */}
            </Tabs>
        </div>
    );
}

export default HomePageMobile;
